const week1 = [
  {
    sessionId: 'yLmIWwKtU0',
    gameTime: '2026-01-03T02:00:00.000Z',
    title: 'Utah / Minnesota / Iowa',
    tags: ['FEMALE'],
    teamA: 'Utah',
    teamALogo: 'upload/images/team/_wCK0UBq2vCRlqzRFrB2S',
    teamB: 'Minnesota',
    teamBLogo: 'upload/images/team/L1nfNwj-98ysElWuNme9W',
    teamC: 'Iowa',
    teamCLogo: 'upload/images/team/p8ENUoErkkuHz3msOYb8d',
  },
  {
    sessionId: 'lpzlHBiSYB',
    gameTime: '2026-01-03T20:00:00.000Z',
    title: 'UW-Oshkosh / Greenville / UW-Stout / Winona State',
    tags: ['FEMALE'],
    teamA: 'UW-Oshkosh',
    teamALogo: 'upload/images/team/Gq5i5lMGRFcxbXrFBVTp9',
    teamB: 'Greenville',
    teamBLogo: 'upload/images/team/DvpQ8aJqMsi2aXyHkqWpb',
    teamC: 'UW-Stout',
    teamCLogo: 'upload/images/team/2uKGYOQeEjD5U6ofcavh2',
    teamD: 'Winona State',
    teamDLogo: 'upload/images/team/WeJiXDNMqwN034-bzJsev',
  },
  {
    sessionId: 'FaeFkI216J',
    gameTime: '2026-01-03T23:00:00.000Z',
    title: 'Washington / California / Oregon State / UCLA',
    tags: ['FEMALE'],
    teamA: 'Washington',
    teamALogo: 'upload/images/team/PxHRrEmCh4h8dFmITMnSM',
    teamB: 'California',
    teamBLogo: 'upload/images/team/AhdgNN4VK4EiOT8YMJavo',
    teamC: 'Oregon State',
    teamCLogo: 'upload/images/team/SUgsb-OU3HGO7oWFRzfhd',
    teamD: 'UCLA',
    teamDLogo: 'upload/images/team/LvA1VLX0gEgeqNb11WmGm',
  },
  {
    sessionId: 'X_9t41xaLU',
    gameTime: '2026-01-04T19:00:00.000Z',
    title: 'Clemson vs Towson',
    tags: ['FEMALE'],
    teamA: 'Clemson',
    teamALogo: 'upload/images/team/M_ZZbKT6N5hoeI9gOzW08',
    teamB: 'Towson',
    teamBLogo: 'upload/images/team/7E-jHUkEK-WMl5uA31it-',
  },
  {
    sessionId: 'Kjw73C9cAD',
    gameTime: '2026-01-04T19:00:00.000Z',
    title: 'Rutgers / Temple / Brockport',
    tags: ['FEMALE'],
    teamA: 'Rutgers',
    teamALogo: 'upload/images/team/Keb4zpuxg0jy2H45dR0dD',
    teamB: 'Temple',
    teamBLogo: 'upload/images/team/-2aUC7ugrc_ZH7Gcip46v',
    teamC: 'Brockport',
    teamCLogo: 'upload/images/team/ghW_zO5ZLUPbYGniXSAR-',
  },
  {
    sessionId: 'CsDcitZCLO',
    gameTime: '2026-01-04T20:00:00.000Z',
    title: 'Missouri vs Iowa State',
    tags: ['FEMALE'],
    teamA: 'Missouri',
    teamALogo: 'upload/images/team/hSA2_OvgGcAwhVnnZDHjL',
    teamB: 'Iowa State',
    teamBLogo: 'upload/images/team/9__Q1pXevKzpCxsjpRkoA',
  },
];

export const matches2026 = [week1];
